import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
//import { LiquidCache } from "ngx-liquid-cache";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseUrlHelperService } from "../helper/baseUrlHelper.service";
import { NbcLoggerService } from "../logger/nbc-logger.service";

@Injectable({
    providedIn: "root",
})
export class BudgetCodeService {
    constructor(
        private http: HttpClient,
        private _apiroot: BaseUrlHelperService,
        private log: NbcLoggerService
    ) {}

    search = (searchObj) => {
        this.log.trace("calling search for object" + JSON.stringify(searchObj));
        return this.http.post(
            this._apiroot.baseUrl + "budget/search/",
            searchObj
        );
    };

    //@LiquidCache("companyCodes")
    getCompanyCodes() {
        this.log.trace("Calling get company codes");
        return this.http.get(this._apiroot.baseUrl + "budget/companyCodes");
    }
}
